import React from 'react';
import { connect } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { UUID } from '../../../types/standard';
import Button from '../../common/Buttons/Button/Button';
import Loading from '../../common/Loading/Loading';
import Modal from '../../common/Modal/Modal';
import styles from '../changeActions.module.scss';
import { ReactComponent as IconTrash } from '../../../assets/moreMenu/trash.svg';
import ButtonsGroup from '../../common/Buttons/ButtonsGroup/ButtonsGroup';
import renderWhen from '../../../helpers/renderWhen';
import { Activitat } from '../../../types/activitat/Activitat.d';
import { del, hide } from '../../../store/activitat/deleteActivitatModule';
import {
  selectDeleteActivitat,
  selectDeleteActivitatActive,
  selectDeleteActivitatLoading,
} from '../../../store/activitat/selectors';

interface DeleteActivitatProps {
  activitat: Activitat | null;
  active: boolean;
  loading: boolean;
  closeModal: () => void;
  deleteActivitat: (id: UUID | undefined) => void;
}

const DeleteActivitat: React.FC<DeleteActivitatProps> = ({
  activitat,
  active,
  loading,
  closeModal,
  deleteActivitat,
}) => {
  // 'active' controls if the modal is open or close
  if (!active) return null;
  return (
    <>
      {activitat && (
        <Modal closeModal={closeModal}>
          <div className={styles.container}>
            <h1 className={styles.title}>
              <IconTrash className={`${styles.icon} ${styles.isIconTrash}`} />
              Eliminar activitat
            </h1>
            <p className={styles.description}>
              Estàs segur/a que vols eliminar l&apos;activitat?
            </p>
            <div className={styles.appointmentWrapper}>
              <div className={styles.description}>
                <p></p>
              </div>
            </div>
            <ButtonsGroup variant="center">
              <Button type="button" variant="negative" onClick={closeModal}>
                Cancel·lar
              </Button>
              {activitat.id && (
                <Button
                  variant="positive"
                  onClick={() => {
                    if (activitat) {
                      deleteActivitat(activitat.id);
                    }
                    closeModal();
                  }}
                  data-testid="submit_button"
                >
                  Eliminar
                </Button>
              )}
            </ButtonsGroup>
            {loading && <Loading />}
          </div>
        </Modal>
      )}
    </>
  );
};

const ConnectedDeleteActivitat = connect(
  (state: RootState) => ({
    activitat: selectDeleteActivitat(state),
    active: selectDeleteActivitatActive(state),
    loading: selectDeleteActivitatLoading(state),
  }),
  (dispatch: AppDispatch) => ({
    deleteActivitat: (payload: UUID | undefined) => dispatch(del(payload)),
    closeModal: () => dispatch(hide()),
  }),
)(DeleteActivitat);

export default renderWhen(
  ConnectedDeleteActivitat,
  selectDeleteActivitatActive,
);
